module.exports = __webpack_public_path__ + "img/1458564981.c4d9821d.jpg";